export default class {
    _id;
    _name;
    _region;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    constructor(id, name) {
        this._id = id;
        this._name = name;
    }
}
